import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { categories } from '../../../../../redux/categories/action';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { products } from '../../../../../redux/products/action';
import { tags } from '../../../../../redux/tags/action';
import { selectTagsListItems } from '../../../../../redux/tags/selector';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectListItems } from '../../../../../redux/library/selector';
import { selectCustomersListItems } from '../../../../../redux/customers/selector';
import { customers } from '../../../../../redux/customers/action';
import OrderPolicyComponent from '../components/order-policy.component';
import { selectProductListItems } from '../../../../../redux/products-summary/selector';
import { selectOrderPolicyQueryItems } from '../../../../../redux/order-policies/selector';
import { orderPolicies } from '../../../../../redux/order-policies/action';


let currentChange: any = {}
const OrderPolicy= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const libraryData = useSelector(selectListItems)
  const tagsLists = useSelector(selectTagsListItems)
  const categoriesLists = useSelector(selectCategoriesListItems)
  const productsLists = useSelector(selectProductListItems)
  const customerLists = useSelector(selectCustomersListItems)
  const queryItems = useSelector(selectOrderPolicyQueryItems)
  const [selectedOrderPolicyValues, setSelectedOrderPolicyValues] = useState([]);
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedOrderPolicys,
    setSelectedOrderPolicys
  ] = useState<any>([])
  // const [
  //   categoryImageIndex,
  //   setOrderPolicyImageIndex
  // ] = useState<any>([])
  // const [
  //   mediaFiles,
  //   setMediaFiles
  // ] = useState<any>([])
  // const [
  //   openFile,
  //   setOpenFile
  // ] = useState<any>([]);

  const fetchQueryById= ()=>{
    dispatch(orderPolicies.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/smart-order-policy/order-policies/query`,entity:'orderPolicies',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
}).then(()=>{
  setIsLoading(false)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedOrderPolicys({ ...selectedOrderPolicys, [field]: event })
  }
  const handleInnerFormChange: any = ({ value, field, data }: any) => {
    currentChange = { value, field, data, idx: 0 }
    const fields = R.split(
      '.',
      field
    );
    const valueData = { ...data, [fields[1]]: value }// inner data update
    setSelectedOrderPolicys({ ...selectedOrderPolicys, [fields[0]]: valueData });
  }
  // const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
  //   const items = deepCopy(mediaFiles);// deep copy of grn items
  //   let item = items[idx];// deep copy of item to be edited
  //   item = { ...item, [field]: value }// updated the particular item
  //   items[idx] = item;
  //   currentChange = { value, field, idx }
  //   setMediaFiles(items);
  // }

  useEffect(
    () => {
      dispatch(tags.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
        entity: 'tags',
        jsonData: {}
        
    })).then(()=>{
      dispatch(categories.list({
        url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
        entity: 'categories',
        jsonData: {}
    }))
    })
     .then(()=>{
      dispatch(products.list({url:`https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/products/list`,entity:'products',jsonData:{ }}))
    }).then(()=>{
      dispatch(customers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/customers/list`,
        entity: 'customers',
        jsonData: {}
    }));
    }) .then(()=>{
      if (parmas?.id > 0) {
        fetchQueryById()

      }else {
        // const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        // setMediaFiles(localSelectedMedia)
        const localSelectedOrderPolicy = addNewOrderPolicyValuesRow({ selectedOrderPolicyValuesArg: selectedOrderPolicyValues });
        setSelectedOrderPolicyValues(localSelectedOrderPolicy)
        setIsLoading(false)
      }
    })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedOrderPolicys(queryItems?.result?.items)
        // const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        // setMediaFiles(localSelectedMedia)
        const orderItemsData: any = queryItems?.result?.items?.Order.map((item: any) => {
          const itemdData = {
            EntityId: item?.EntityId,
            EntityTypeId: item?.EntityTypeId,
            ReturnPeriod: item?.Return?.ReturnPeriod
          }
          return itemdData
        })
        const localSelectedOrderPolicy = addNewOrderPolicyValuesRow({ selectedOrderPolicyValuesArg:  orderItemsData});
        setSelectedOrderPolicyValues(localSelectedOrderPolicy)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    // mediaFiles.splice(
    //   mediaFiles.length - 1,
    //   1
    // )
    selectedOrderPolicyValues.splice(
      selectedOrderPolicyValues.length - 1,
      1
    )
    const orderItemsData: any = selectedOrderPolicyValues.map((item: any) => {
      const itemdData = {
        EntityId: item?.EntityId,
        EntityTypeId: selectedOrderPolicys?.OrderTypeId,
        Return: {
          ReturnPeriod: item?.ReturnPeriod
        }
      }
      return itemdData
    })
    
  const fulfillmentCentreData ={
    "IsActive": selectedOrderPolicys?.IsActive,
      "Name": selectedOrderPolicys?.Name,
      "OrderTypeId": selectedOrderPolicys?.OrderTypeId,
      "StartDateUtc": selectedOrderPolicys?.StartDateUtc,
      "EndDateUtc": selectedOrderPolicys?.EndDateUtc,
      "Remarks": selectedOrderPolicys?.Remarks,
      "DisplayOrder": selectedOrderPolicys?.DisplayOrder,
      "Description": selectedOrderPolicys?.Description,
      "Inclusions": selectedOrderPolicys?.Inclusions,
      "Exclusions": selectedOrderPolicys?.Exclusions,
      "MediaMappings": {
        "MediaFiles": [],
        "Templates": [
          
        ]
      },
      "Order": orderItemsData
  }
    if (parmas?.id > 0) {
     dispatch(orderPolicies.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/smart-order-policy/order-policies`,entity:'orderPolicies',jsonData:{
          
    Records: [
      fulfillmentCentreData
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      dispatch(orderPolicies.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/smart-order-policy/order-policies`,entity:'orderPolicies',jsonData:{
          
      Records: [
        fulfillmentCentreData
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/agencies/policies/orderpolicy')
} 
// const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
//   const localSelectedmedia = deepCopy(selectedMediaFilesArg)
//   const newsSelectedMedia = {
//     Id: 0,
//     FileTypeId: 0,
//     OwnerTypeId: 164,
//     FileMappingURL: ''
//   }
//   if (localSelectedmedia.length === 0 ||
//     localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
//   ) {
//     localSelectedmedia?.push(newsSelectedMedia)
//   }

//   return localSelectedmedia
// }
// const setMediaInfo = async () => {
//   let localSelectedMedia = deepCopy(mediaFiles)
//   localSelectedMedia.splice(
//     currentChange.idx,
//     1,
//     { ...localSelectedMedia[currentChange.idx] }
//   );
//   localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
//   currentChange.field = 'FileTypeIdDONE'
//   setMediaFiles(localSelectedMedia)
// }
// const changeImage = (idx: number, templateField: any, fileType: any) => {
//   setOrderPolicyImageIndex(idx)
//   dispatch(settings.set({ getUploadFiles: 'open' }))
//   setOpenFile({
//     currentFileSrc: mediaFiles[idx][templateField],
//     folder: 'OrderPolicy',
//     type: fileType
//   })
// }
// const handleSubmit = (data: any) => {

//   mediaFiles[categoryImageIndex].FileMappingURL = data
//   const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
//   setMediaFiles(localSelectedMedia)
// }
const addNewOrderPolicyValuesRow = ({ selectedOrderPolicyValuesArg }: any) => {
  const localSelectedOrderPolicyValues = deepCopy(selectedOrderPolicyValuesArg);
  const newOrderPolicyValue = {
    Id: 0,
    EntityId: 0,
    EntityTypeId: selectedOrderPolicys?.OrderTypeId,
    Return: {
      ReturnPeriod: 0
    }
  };
  if (
    localSelectedOrderPolicyValues.length === 0 ||
    localSelectedOrderPolicyValues[localSelectedOrderPolicyValues?.length - 1]
      ?.EntityId !== 0
  ) {
    localSelectedOrderPolicyValues?.push(newOrderPolicyValue);
  }

  return localSelectedOrderPolicyValues;
};
const handleFormOrderPolicyItemChange: any = ({ value, field, idx }: any) => {
  const items = deepCopy(selectedOrderPolicyValues); // deep copy of items
  let item = items[idx]; // deep copy of item to be edited
  item = { ...item, [field]: value }; // updated the particular item
  items[idx] = item;
  currentChange = { value, field, idx };
  setSelectedOrderPolicyValues(items);
};
const setOrderPolicyValuesInfo = async () => {
  let localOrderPolicyValues = deepCopy(selectedOrderPolicyValues);
  localOrderPolicyValues.splice(currentChange.idx, 1, {
    ...localOrderPolicyValues[currentChange.idx],
  });
  localOrderPolicyValues = addNewOrderPolicyValuesRow({
    selectedOrderPolicyValuesArg: localOrderPolicyValues,
  });
  currentChange.field = 'EntityIdDONE';
  setSelectedOrderPolicyValues(localOrderPolicyValues);
};
useEffect(() => {
  if (currentChange.field === 'EntityId') {
    setOrderPolicyValuesInfo();
  }
}, [selectedOrderPolicyValues]);

// const handleClose = () => {
//   dispatch(settings.set({ getUploadFiles: 'close' }))
  
// }

// useEffect(
//   () => {
//     if (currentChange.field === 'FileTypeId') {
//       setMediaInfo()
//     }
//   },
//   [mediaFiles]
// )
   return (
      <>
      {/* {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
     folder={openFile?.folder}
          handleClose={handleClose}
          handleFilesSubmit={handleSubmit}
          type={openFile?.type}
          ownerId={parmas?.id}
          />} */}
     {isLoading ? <PageLoader /> : 
     
    
          <OrderPolicyComponent 
          onInnerBasicFormChange={handleInnerbasicFormChange}
          selectedOrderPolicys={selectedOrderPolicys}
          //fileTypes={libraryData?.result?.FileType}
          entityTypes={libraryData?.result?.EntityTypes}
          messagePeriods={libraryData?.result?.MessageDelayPeriod}
           categories={categoriesLists?.result?.items}
          products = {productsLists?.result?.items}
          allTags={tagsLists?.result?.items}
           back={back}
           onInnerFormChange={handleInnerFormChange}
           handleFormSubmit={handleFormSubmit}
           //handleFormMediaItemChange={handleFormMediaItemChange}
           //mediaFiles={mediaFiles}
           //changeImage={changeImage}
           id={parmas?.id}

           customers={customerLists?.result?.items}
           selectedOrderPolicyValues={selectedOrderPolicyValues}
           handleFormOrderPolicyItemChange={handleFormOrderPolicyItemChange}
          />  
     }
     
           </>
    )
    
    }
   
    export default OrderPolicy;